import React, { FC, memo, useRef } from 'react';

import { formatDate, parseDate, weekEnd } from './utils';
import {
  Container,
  DayPickerInput,
  DayPickerStyles,
  Separation,
  LastDatePicker,
} from './styles';

import 'react-day-picker/lib/style.css';

const WeekRangePicker: FC<any> = ({
  fromHandleChange,
  toHandleChange,
  from,
  to,
  hoverRange,
  selectedDays,
  handleDayChange,
  handleDayEnter,
  handleDayLeave,
  handleWeekClick,
  disableFutureWeeksPick = false,
  fromLimit,
  toLimit,
  ...props
}) => {
  const daysAreSelected = selectedDays.length > 0;
  const datesCopy = [...selectedDays];
  const firstDate = datesCopy.shift();
  const lastDate = datesCopy.pop();
  const modifiers = {
    hoverRange,
    selectedRange: daysAreSelected && {
      from: firstDate,
      to: lastDate,
    },
    hoverRangeStart: hoverRange.from && hoverRange.from,
    hoverRangeEnd: hoverRange.to && hoverRange.to,
    start: daysAreSelected && firstDate,
    end: daysAreSelected && lastDate,
    sunday: hoverRange.from,
  };
  const leftPicker = useRef();
  const openPicker = () => {
    /* @ts-ignore */
    leftPicker.current.showDayPicker();
  };
  const formatedLastDate = formatDate(lastDate);
  return (
    <>
      <Container onClick={openPicker} {...props}>
        <DayPickerStyles>
          <DayPickerInput
            {...props}
            ref={leftPicker}
            value={firstDate}
            formatDate={formatDate}
            placeholder=""
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays,
              modifiers,
              disabledDays: [
                ...(fromLimit ? [{ before: fromLimit }] : []),
                ...(toLimit ? [{ after: toLimit }] : []),
                ...(disableFutureWeeksPick ? [{ after: weekEnd }] : []),
              ],
              onDayClick: (day: Date, dayModifiers: { disabled: Boolean }) => {
                if (dayModifiers.disabled) {
                  return;
                }
                handleDayChange(day);
              },
              onDayMouseEnter: handleDayEnter,
              onDayMouseLeave: handleDayLeave,
              onWeekClick: handleWeekClick,
              firstDayOfWeek: 1,
              numberOfMonths: 2,
            }}
          />
        </DayPickerStyles>

        <Separation />

        <LastDatePicker>{formatedLastDate}</LastDatePicker>
      </Container>
    </>
  );
};

export default memo(WeekRangePicker);
